import script from "./Modal-Nuevo-Articulo.vue?vue&type=script&setup=true&lang=js"
export * from "./Modal-Nuevo-Articulo.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__